<template>
  <f7-panel left class="panelBackground">
    <!-- Identity header -->
    <mobile-identity-header :username="userName"/>

    <!-- Profile options container -->
    <mobile-menu-container>
      <mobile-menu-section-list-item
        class="profileInformationContainer"
        labelId="leftPanelTitle.my_prfl"
        @click="goToLink('/profile/')">
      </mobile-menu-section-list-item>
      <mobile-menu-section-list-item
        class="profileInformationContainer"
        labelId="leftPanelTitle.swtch_prfl"
        @click="activateModalProfile">
      </mobile-menu-section-list-item>
      <mobile-menu-section-list-item
        class="profileInformationContainer"
        labelId="Webheader.settings"
        @click="goToLink('/settings/application/')">
      </mobile-menu-section-list-item>
      <mobile-menu-section-list-item
        v-if="this.accountType === '1'"
        class="profileInformationContainer"
        labelId="Webheader.company_members"
        @click="goToLink('/accountMembers/')">
      </mobile-menu-section-list-item>
      <mobile-menu-section-list-item
        class="profileInformationContainer"
        labelId="leftPanelTitle.lgout"
        @click="logoutWait">
      </mobile-menu-section-list-item>
    </mobile-menu-container>

    <!-- Navigation menu -->
    <mobile-menu-container>
      <!-- Section (with included header) -->
      <mobile-menu-section
        v-for="item in menu" :key="item.id"
        v-if="!isDisabledItem(item)"
        :headerLabelId="item.title">

          <!-- if List of items -->
          <div v-if="item.list">
            <mobile-menu-section-list-item
              v-for="subItem in item.list" :key="subItem.id"
              v-if="subItem.id !== 0 && subItem.enabled"
              :labelId="subItem.titleShort"
              :disabled="isDisabledItem(subItem)"
              @click="getClicked(subItem)">
            </mobile-menu-section-list-item>
          </div>

          <!-- else if One item with link -->
          <div v-else-if="item.link">
            <mobile-menu-section-list-item
              :labelId="item.titleShort"
              :disabled="isDisabledItem(item)"
              @click="getClicked(item)">
            </mobile-menu-section-list-item>
          </div>
      </mobile-menu-section>
    </mobile-menu-container>
  </f7-panel>
</template>

<script>
import menuLinkList from '@/components/menus/menu.json'
import {reloadPage2} from './../../helpers/routing'
import MobileMenuContainer from '@/components/menus/MobileMenuComponents/MobileMenuContainer'
import MobileMenuSection from '@/components/menus/MobileMenuComponents/MobileMenuSection'
import MobileMenuSectionListItem from '@/components/menus/MobileMenuComponents/MobileMenuSectionListItem'
import MobileIdentityHeader from '@/components/menus/MobileMenuComponents/MobileIdentityHeader'
import Services from '@/helpers/services'

export default {
  name: 'MobileLeftPanel',
  components: {
    'mobile-menu-container': MobileMenuContainer,
    'mobile-menu-section': MobileMenuSection,
    'mobile-menu-section-list-item': MobileMenuSectionListItem,
    'mobile-identity-header': MobileIdentityHeader
  },
  data () {
    return {
      currentLink: '',
      currentSubitem: {},
      windowWidth: window.innerWidth,
      menu: [],
      userName: '',
      accountType: '0'
    }
  },
  created () {
    this.menu = menuLinkList['linkContent']
    this.userName = this.$engine.user.get().name
    this.accountType = this.$engine.user.get().type
    // window.addEventListener('resize', this.handleResize)

    this.$bus.$on('refresh-cache-menu', () => {
      this.userName = this.$engine.user.get().name
      this.accountType = this.$engine.user.get().type
    })
  },
  methods: {
    handleResize () {
      let that = this
      that.windowWidth = window.innerWidth
      that.$engine.services.directPayments.filter.smartphoneStorage = !that.isLaptop
      that.$bus.emit('window-resize')
    },
    getClicked (subitem) {
      if (!subitem.link) {
        return
      }
      this.currentSubitem = subitem
      this.Dom7('.panel-left').on('panel:closed', this.loadPageFromRoute)
    },
    goToLink (linkToGo) {
      this.currentLink = linkToGo
      this.Dom7('.panel-left').on('panel:closed', this.loadPageFromLink)
    },
    logout () {
      this.Dom7('.panel-left').off('panel:closed')
      this.$bus.emit('logout')
    },
    logoutWait () {
      this.Dom7('.panel-left').on('panel:closed', this.logout)
    },
    loadPageFromLink () {
      let that = this
      this.Dom7('.panel-left').off('panel:closed')
      reloadPage2(that, this.currentLink)
    },
    loadPageFromRoute () {
      this.Dom7('.panel-left').off('panel:closed')
      let subitem = this.currentSubitem
      switch (subitem.link) {
        case '/directPayments/creation/':
          this.$bus.$emit('service:change', 'Direct Payments')
          this.$bus.$emit('direct-inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTPAYMENTS))
          this.$engine.user.currentService.id = Services.DIRECTPAYMENTS
          break
        case '/payments/newPayments/':
          this.$bus.$emit('service:change', 'Payments')
          this.$bus.$emit('direct-debit-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.PAYMENTS))
          this.$engine.user.currentService.id = Services.PAYMENTS
          break
        case '/directDebit/creation/':
          this.$bus.$emit('service:change', 'Direct Debit')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTDEBIT))
          this.$engine.user.currentService.id = Services.DIRECTDEBIT
          break
        case '/businessDocument/sendForm/':
        case '/businessDocument/requestForm/':
          this.$bus.$emit('service:change', 'Business Documents')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DOCUMENTSERVICE))
          this.$engine.user.currentService.id = Services.DOCUMENTSERVICE
          break
        case '/suppliers/create/':
          this.$bus.$emit('service:change', 'Suppliers')
          this.$bus.$emit('inbox-filtered', 1)
          this.$engine.user.changeService(this.$engine.services.getServiceById(Services.SUPPLIERS))
          this.$engine.user.currentService.id = Services.SUPPLIERS
          break
        case String(subitem.link.match('^/inbox/.*')):
          switch (subitem.service) {
            case 1:
              this.$bus.$emit('service:change', 'Payments')
              this.$bus.$emit('direct-debit-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.PAYMENTS))
              this.$engine.user.currentService.id = Services.PAYMENTS
              break
            case 2:
              this.$bus.$emit('service:change', 'Direct Debit')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTDEBIT))
              this.$engine.user.currentService.id = Services.DIRECTDEBIT
              break
            case 6:
              this.$bus.$emit('service:change', 'Direct Payments')
              this.$bus.$emit('direct-inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DIRECTPAYMENTS))
              this.$engine.user.currentService.id = Services.DIRECTPAYMENTS
              break
            case 7:
              this.$bus.$emit('service:change', 'Business Documents')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.DOCUMENTSERVICE))
              this.$engine.user.currentService.id = Services.DOCUMENTSERVICE
              break
            case 8:
              this.$bus.$emit('service:change', 'Suppliers')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.SUPPLIERS))
              this.$engine.user.currentService.id = Services.SUPPLIERS
              break
            case 9:
              this.$bus.$emit('service:change', 'Verifications')
              this.$bus.$emit('inbox-filtered', 1)
              this.$engine.user.changeService(this.$engine.services.getServiceById(Services.VERIFICATIONS))
              this.$engine.user.currentService.id = Services.VERIFICATIONS
              break
            default:
            /*  "Tous les services", à reprendre plus tard
            {id: 4, title: 'Webheader.all_usages', link: '/inbox/'} */
              break
          }
          break
        default:
          break
      }
      let that = this
      reloadPage2(that, subitem.link)
    },
    activateModalProfile () {
      this.$f7.popup('#switch-profile-true')
    },
    isDisabledItem (item) {
      if (item && item.right_disable && item.right_disable.right) { // If item has a right value
        // Return true if the right has the same state as the disabling state
        return this.$engine.rights.rightIs(item.right_disable.right, item.right_disable.state)
      }
      return false
    }
  },
  computed: {
    isLaptop () {
      return this.windowWidth >= 1024
    }
  }
}
</script>
<style>
.menuItemTitle {
  color: var(--headbandTextColor) !important;
}
.panelBackground {
  background-color: var(--headbandColor);
  box-shadow: 1px 0px 5px grey;
  max-width: 255px;
  overflow-x: hidden;
  width: 75%;
}
.profileInformationContainer {
  color: white;
}
.subMenuItem {
  color: var(--headbandTextColor);
}
</style>



// WEBPACK FOOTER //
// MobileLeftPanel.vue?4333fee6